import { render } from "./ModalTermsAcceptanceReminder.vue?vue&type=template&id=7b7e2c9d"
import script from "./ModalTermsAcceptanceReminder.vue?vue&type=script&lang=js"
export * from "./ModalTermsAcceptanceReminder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/views/accounts/AccountView/Settings/ModalTermsAcceptanceReminder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b7e2c9d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b7e2c9d', __exports__)) {
    api.reload('7b7e2c9d', __exports__)
  }
  
  module.hot.accept("./ModalTermsAcceptanceReminder.vue?vue&type=template&id=7b7e2c9d", () => {
    api.rerender('7b7e2c9d', render)
  })

}


export default __exports__